import classic from 'ember-classic-decorator';

import ApplicationSerializer from './application';

@classic
export default class LinkinbioPostSerializer extends ApplicationSerializer {
  attrs = {
    linkinbioPostLinks: {
      key: 'linkinbio_post_links_attributes',
      embedded: 'always',
      serialize: 'records'
    }
  };
}
